import { baseServiceRequest } from "@apis/baseServiceRequest"
import type {
  IAcceptWinbackOfferRequest,
  IAcceptWinbackOfferResponse,
  IWinback,
  IWinbackOffersResponse,
} from "./types"
import type { AxiosResponse } from "axios"
import type { IUserIdParams } from "@commonTypes/user"

export const getWinback = async (account_id: string): Promise<IWinback> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/winbacks/account/${account_id}`,
  })
  return response.data
}

export const getWinbackOffers = async (
  account_id: string,
  params: IUserIdParams,
): Promise<AxiosResponse<IWinbackOffersResponse>> => {
  return baseServiceRequest({
    method: "GET",
    url: `/winbacks/offers/${account_id}`,
    params,
  })
}

export const acceptWinbackOffer = async ({
  account_id,
  offer_code,
  request,
}: {
  account_id: string
  offer_code: string
  request: IAcceptWinbackOfferRequest
}): Promise<IAcceptWinbackOfferResponse> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: `/winbacks/offers/${offer_code}/accept/${account_id}`,
    data: request,
  })
  return response.data
}
